import React from "react";
import { Slide } from "react-reveal";
import Cta from "../reusables/Cta";

const OurProducts = () => {
  return (
    <section className=" section-spacing-100 threads-bg">
      <div className="large">
        <div className="section-content-container">
          <div className="section-content">
            <div className="width-600 margin-auto center">
              <Slide top>
                <div className="section-head">
                  <h2 className="section-title dark">OUR PRODUCTS</h2>
                  <p className="section-subtitle margin-top-bottom-10 dark">
                    Lasting impressions are our bread and butter, and we’re
                    committed to exceptional service and aim to make every event
                    a memorable occasion.
                  </p>
                </div>
              </Slide>
            </div>
            <div className="section-body section-spacing-20">
              <div className="products-container flex">
                <Slide left>
                  <div className="side side-a">
                    <ol>
                      <li>1. Stage/Truss</li>
                      <li>2. PA System</li>
                      <li>3. Intelligent Lighting</li>
                    </ol>
                  </div>
                </Slide>
                <Slide bottom>
                  <div className="side side-b">
                    <ol>
                      <li>4. Large Scale Super Silent Generators</li>
                      <li>5. Led Screens</li>
                      <li>
                        6. Special Effects:- Lasers, CO2, Sparks, Confetti
                      </li>
                    </ol>
                  </div>
                </Slide>
              </div>
            </div>
            <Slide top>
              <div className="section-footer buttons-container flex justify-center section-spacing-20 no-padding-bottom">
                <Cta />
              </div>
            </Slide>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurProducts;
